import React, { useRef } from "react";

import { Row, Col } from "react-bootstrap";
import { FiDownload } from "react-icons/fi";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  LedgerOpening,
  OpeningFun,
} from "../../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";
import FASTable from "../../../../../components/Tables/FASTable";
import { Loader } from "../../../../../components/Loader/Loader";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function Opening({
  accountName,
  accountGroup,
  startDate,
  endDate,
}) {
  const dispatch = useDispatch();

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);
  const { LedgerOpeningdata } = useSelector((state) => state.LedgerSlice);

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";
    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return "";
    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const formatIndianAmount = (value) => {
    if (!value) return "0.00";

    const str = String(value).trim();

    // Number extract
    const numberMatch = str.match(/-?\d+(\.\d+)?/);

    if (!numberMatch) return value;

    const num = Number(numberMatch[0]);

    // Cr / Dr extract
    const typeMatch = str.match(/\b(Cr|Dr)\b/i);
    const type = typeMatch ? typeMatch[0] : "";

    const formattedNumber = num.toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return `${formattedNumber} ${type}`.trim();
  };

  const firstRender = useRef(true);
  const getRows = LedgerOpeningdata?.Detail?.map((row, index) => ({
    // srNumber: index + 1,
    VouDate: formatDateToDDMMYYYY(row.VouDate),
    VouNo: row.VouNo,
    DocumentNo: row.DocumentNo,
    TransactionName: row.TransactionName,
    Debit: row.Debit,
    Credit: row.Credit,
    Balance: row.Balance,
    BalAmtType: row.BalAmtType,
  }));

  const getColumns = [
    { label: "Sr. No.", key: "srNumber", align: "center" },
    { label: "Vou Date", key: "VouDate", align: "center" },
    { label: "Vou No", key: "VouNo", align: "right" },
    { label: "Document No", key: "DocumentNo", align: "right" },
    {
      label: "Transaction Name",
      key: "TransactionName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Debit", key: "Debit", align: "right", format: true },
    { label: "Credit", key: "Credit", align: "right", format: true },
    { label: "Balance", key: "Balance", align: "right", format: true },
    { label: "Bal Type", key: "BalAmtType", align: "left" },
  ];
  const handleDownload = () => {
    try {
      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      const marginX = 14;

      // ---------------- TITLE ----------------
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");

      doc.text("Opening Ledger Report", pageWidth / 2, 15, {
        align: "center",
      });

      doc.setLineWidth(0.5); // bold line
      doc.line(marginX, 18, pageWidth - marginX, 18);

      // ---------------- FIRM NAME ----------------
      const firmName =
        DataMain?.Firm_Dtl?.[0]?.FirmName ||
        DataMain?.Firm_List?.[0]?.GroupName ||
        "";

      doc.setFontSize(12);
      doc.setFont("helvetica", "bold");

      doc.text(firmName, pageWidth / 2, 25, {
        align: "center",
      });

      // ---------------- DATA SAFE ----------------
      const details = LedgerOpeningdata?.AccountDetail?.[0] || {};
      const summary = LedgerOpeningdata?.LedgerSumm?.[0] || {};

      const openingAmount = details?.OpAmount || 0;
      const balanceAmount = summary?.Balance || 0;

      let yPos = 35;

      // ---------------- LEFT DETAILS ----------------
      doc.setFontSize(11);
      doc.setFont("helvetica", "normal");

      doc.text(`A/c Name : ${details?.AcName || "-"}`, marginX, yPos);
      yPos += 8;

      doc.text(`Pan No : ${details?.PanNo || "-"}`, marginX, yPos);
      yPos += 8;

      doc.text(`Address : ${details?.Address || "-"}`, marginX, yPos);
      yPos += 8;

      doc.text(`City : ${details?.CityName || "-"}`, marginX, yPos);

      // ---------------- RIGHT SIDE ----------------
      const rightEdge = pageWidth - marginX;

      doc.setFont("helvetica", "bold");

      const openingText = `Opening : ${formatIndianAmount(openingAmount || 0)}`;

      const balanceText = `Balance : ${formatIndianAmount(balanceAmount || 0)}`;

      doc.text(openingText, rightEdge - doc.getTextWidth(openingText), 50);

      doc.text(balanceText, rightEdge - doc.getTextWidth(balanceText), 57);

      yPos += 14;

      doc.setLineWidth(0.5);
      doc.line(marginX, yPos, pageWidth - marginX, yPos);
      // ---------------- TABLE DATA ----------------
      // TOTALS
      const ledgerTotal = LedgerOpeningdata?.LedgerSumm?.[0] || {};

      const totalDebit = ledgerTotal?.Debit || 0;
      const totalCredit = ledgerTotal?.Credit || 0;
      const totalBalance = ledgerTotal?.Balance || 0;

      const tableRows =
        LedgerOpeningdata?.Detail?.map((row, index) => [
          index + 1,
          formatDateToDDMMYYYY(row?.VouDate),
          row?.VouNo || "-",
          row?.DocumentNo || "-",
          row?.TransactionName || "-",
          formatIndianAmount(row?.Debit || 0),
          formatIndianAmount(row?.Credit || 0),
          formatIndianAmount(row?.Balance || 0),
          row?.AmtType || "-",
        ]) || [];

      // ✅ TOTAL ROW ADD
      tableRows.push([
        "",
        "",
        "",
        "",
        "TOTAL",
        formatIndianAmount(totalDebit),
        formatIndianAmount(totalCredit),
        formatIndianAmount(totalBalance),
        "",
      ]);

      const pdfColumnStyles = {
        0: { halign: "center" },
        1: { halign: "center" },
        2: { halign: "left" },
        3: { halign: "right" },
        4: { halign: "left" },
        5: { halign: "right" },
        6: { halign: "right" },
        7: { halign: "right" },
        8: { halign: "center" },
      };

      const totalTableWidth = 214;
      const startX = (pageWidth - totalTableWidth) / 2;

      getColumns.forEach((col, index) => {
        if (pdfColumnStyles[index]) {
          pdfColumnStyles[index].halign = col.align || "left";
        }
      });

      autoTable(doc, {
        startY: yPos + 7,

        head: [
          [
            "Sr No",
            "Date",
            "Vou No",
            "Document No",
            "Transaction Name",
            "Debit",
            "Credit",
            "Balance",
            "Type",
          ],
        ],

        body: tableRows,

        theme: "grid",

        tableWidth: totalTableWidth,

        margin: {
          left: startX,
        },

        columnStyles: pdfColumnStyles,

        styles: {
          fontSize: 8,
          textColor: [0, 0, 0],
          fontStyle: "bold",
          lineColor: [210, 210, 210],
          lineWidth: 0.2,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fillColor: [220, 220, 220],
          textColor: [0, 0, 0],
          fontStyle: "bold",
          halign: "center",
          valign: "middle",
          fontSize: 9,
        },

        didParseCell: function (data) {
          // Last row = TOTAL row
          if (
            data.section === "body" &&
            data.row.index === tableRows.length - 1
          ) {
            data.cell.styles.fillColor = [220, 220, 220]; // Light Yellow
            data.cell.styles.fontStyle = "bold";
            data.cell.styles.textColor = [0, 0, 0];
          }
        },
      });

      doc.save("Opening_Ledger_Report.pdf");
    } catch (error) {
      console.error("PDF ERROR:", error);
    }
  };

  if (accountName.length === 0) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "100vh",
          fontSize: "20px",
          color:
            isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour10,
        }}
      >
        Please Select Accounts Name
      </div>
    );
  }
  if (LedgerOpeningdata === "no" || LedgerOpeningdata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  return (
    <div style={{ paddingTop: "16px" }}>
      <style>{`
        .common-hover-btn {
          transition: transform 0.25s ease, box-shadow 0.25s ease, filter 0.25s ease;
          transform: scale(1);
        }
        .common-hover-btn:hover {
          transform: scale(1.01);
        }
        .common-hover-btn:active {
          transform: scale(0.98);
        }
      `}</style>

      <Row>
        <Col xs={12}>
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
              borderRadius: "16px",
              boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
              padding: "24px",
              border: `2px solid ${isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour7}`,
            }}
          >
            <Row className="g-4 align-items-stretch">
              {/* LEFT CONTENT */}
              <Col xl={6} lg={6} md={12}>
                <div
                  style={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  }}
                >
                  <div>
                    <Row className="g-3">
                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            A/c Name:
                          </span>
                          <span
                            style={{
                              fontSize: "18px",
                              fontWeight: "800",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerOpeningdata?.AccountDetail?.[0]?.AcName ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col md={6} xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            Pan No:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerOpeningdata?.AccountDetail?.[0]?.PanNo ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "center",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            City:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                              lineHeight: "1.4",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            {LedgerOpeningdata?.AccountDetail?.[0]?.CityName ||
                              "-"}
                          </span>
                        </div>
                      </Col>

                      <Col xs={12}>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "nowrap",
                            alignItems: "flex-start",
                            paddingLeft: "8px",
                            width: "100%",
                            minHeight: "32px",
                          }}
                        >
                          <span
                            style={{
                              fontSize: "13px",
                              fontWeight: "700",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              width: "95px",
                              minWidth: "95px",
                              lineHeight: "1.6",
                            }}
                          >
                            Address:
                          </span>
                          <span
                            style={{
                              fontSize: "16px",
                              fontWeight: "700",
                              lineHeight: "1.6",
                              color:
                                isdark === "light"
                                  ? iscolour?.Colour12
                                  : iscolourDark?.Colour11,
                              flex: 1,
                              minWidth: 0,
                            }}
                          >
                            {LedgerOpeningdata?.AccountDetail?.[0]?.Address ||
                              "-"}
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "flex-end",
                    }}
                  >
                    <button
                      onClick={handleDownload}
                      className="common-hover-btn"
                      style={{
                        background:
                          isdark === "light"
                            ? iscolour?.Colour6
                            : iscolourDark?.Colour10,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour4,
                        border: "none",
                        borderRadius: "10px",
                        padding: "12px 18px",
                        fontWeight: "700",
                        fontSize: "15px",
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        cursor: "pointer",
                      }}
                    >
                      <FiDownload size={16} />
                      Download PDF
                    </button>
                  </div>
                </div>
              </Col>

              {/* RIGHT SIDE */}
              <Col xl={6} lg={6} md={12}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    height: "100%",
                    gap: "12px",
                  }}
                >
                  {/* BOX 1 */}
                  <div
                    className="common-hover-btn"
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                      border: `1px solid ${
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour10
                      }`,
                      borderLeft: `6px solid ${
                        isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "12px",
                      width: "100%",
                      padding: "25px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          minWidth: "95px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour12,
                          letterSpacing: "2px",
                        }}
                      >
                        OPENING :
                      </span>

                      <span
                        style={{
                          fontSize: "28px",
                          fontWeight: "800",
                          textAlign: "center",
                          flex: 1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour12,
                          lineHeight: "1",
                        }}
                      >
                        {formatIndianAmount(
                          LedgerOpeningdata?.AccountDetail?.[0]?.OpAmount || 0,
                        )}
                      </span>

                      <div style={{ minWidth: "95px" }}></div>
                    </div>
                  </div>

                  {/* BOX 2 */}
                  <div
                    className="common-hover-btn"
                    style={{
                      background:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour2,
                      border: `1px solid ${
                        isdark === "light"
                          ? iscolour?.Colour3
                          : iscolourDark?.Colour10
                      }`,
                      borderLeft: `6px solid ${
                        isdark === "light"
                          ? iscolour?.Colour6
                          : iscolourDark?.Colour10
                      }`,
                      borderRadius: "12px",
                      width: "100%",
                      padding: "25px",
                      height: "100px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                      }}
                    >
                      <span
                        style={{
                          fontSize: "13px",
                          fontWeight: "700",
                          minWidth: "95px",
                          color:
                            isdark === "light"
                              ? iscolour?.Colour5
                              : iscolourDark?.Colour12,
                          letterSpacing: "2px",
                        }}
                      >
                        BALANCE :
                      </span>

                      <span
                        style={{
                          fontSize: "26px",
                          fontWeight: "800",
                          textAlign: "center",
                          flex: 1,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour12
                              : iscolourDark?.Colour12,
                          lineHeight: "1.2",
                        }}
                      >
                        {formatIndianAmount(
                          LedgerOpeningdata?.LedgerSumm?.[0]?.Balance || 0,
                        )}
                      </span>

                      <div style={{ minWidth: "95px" }}></div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Col>

        {/* TABLE */}
        <Col xs={12}>
          <div style={{ marginTop: "20px" }}>
            <div
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
              }}
            >
              <div
                style={{
                  backgroundColor:
                    isdark === "light"
                      ? iscolour?.Colour5
                      : iscolourDark?.Colour4,
                  color:
                    isdark === "light"
                      ? iscolour?.Colour1
                      : iscolourDark?.Colour11,
                  padding: "14px",
                  margin: 0,
                }}
              >
                <h2
                  style={{
                    fontSize: "18px",
                    margin: 0,
                    letterSpacing: "1px",
                    fontWeight: "600",
                  }}
                >
                  OPENING
                </h2>
              </div>
              <FASTable
                data={getRows}
                columns={getColumns}
                externalTotals={LedgerOpeningdata?.LedgerSumm?.[0]}
              />
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
